export default "__VITE_ASSET__D8KfT64N__"